import React from 'react';
import { Routes, Route } from 'react-router-dom';


import './App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';



// Pages
import Home from './pages/Home';
import AboutUs from './pages/AboutUs'
import Courses from './pages/Courses';
import TestSeries from './pages/TestSeries';
import Contact from './pages/Contact';
import DownloadPage from './pages/DownloadPage';
import CounsellingPage from './pages/CounsellingPage';
import Blogs from './pages/Blogs';
import Gallery from './pages/Gallery';
import TopperSlider from './pages/TopperSlider';
import DirectorDesk from './pages/DirectorDesk';
import CurrentAffairs from './pages/CurrentAffairs';







function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />

      {/* Main content */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs/>} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/test-series" element={<TestSeries />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/downloads" element={<DownloadPage />} />
          <Route path="/counselling" element={<CounsellingPage />} />
          <Route path="/blog" element={<Blogs />} />
          <Route path="/gallery" element={<Gallery />} />
                    <Route path="/topperslider" element={<TopperSlider />} />
                                        <Route path="/directordesk" element={<DirectorDesk />} />
          <Route path="/currentaffairs" element={<CurrentAffairs />} />
        </Routes>
      </main>

      <Footer />
    </div>

    
  );
}

export default App;
